import {
	ActionIcon,
	Alert,
	Container,
	Group,
	Skeleton,
	Stack,
	Text,
	Title,
	Tooltip,
} from "@mantine/core";
import {
	IconAlertCircle,
	IconInfoCircle,
	IconRefresh,
} from "@tabler/icons-react";
import type { ReactNode } from "react";
import {
	AiAssistantAdminProvider,
	type AiAssistantAdminValue,
} from "./ai-assistant-admin-context";
import { useAiAssistantAdmin } from "./use-ai-assistant-admin";

/** Kerangka bersama semua sub menu AI: judul, muat ulang, peringatan, dan pemuatan overview sekali. */
export function AiAssistantAdminLayout({ children }: { children: ReactNode }) {
	const admin = useAiAssistantAdmin();
	const { overview, loading, error, unavailable, refresh } = admin;
	const value: AiAssistantAdminValue = {
		...admin,
		disabled: loading || unavailable,
	};

	return (
		<Container size="xl" py="xl">
			<Stack gap="lg">
				<Group justify="space-between" align="flex-start">
					<Stack gap={2}>
						<Title order={2}>AI Assistant</Title>
						<Text size="sm" c="dimmed">
							Nama, saklar, batas pemakaian, dan kredensial per fitur (Chat,
							Penunjuk, Suara) dan mode penyedia.
						</Text>
					</Stack>
					<Group gap="xs" wrap="nowrap">
						<Tooltip label="Muat ulang">
							<ActionIcon
								variant="light"
								onClick={refresh}
								loading={loading}
								aria-label="Muat ulang"
							>
								<IconRefresh size={18} />
							</ActionIcon>
						</Tooltip>
					</Group>
				</Group>

				{unavailable && (
					<Alert color="blue" icon={<IconInfoCircle size={16} />}>
						Endpoint admin AI Assistant tidak terjangkau dari server ini. Form
						menampilkan nilai default dan belum bisa disimpan.
					</Alert>
				)}
				{error && (
					<Alert color="red" icon={<IconAlertCircle size={16} />}>
						{error}
					</Alert>
				)}
				{!unavailable && !loading && !overview.cryptoConfigured && (
					<Alert color="yellow" icon={<IconAlertCircle size={16} />}>
						AI_CREDENTIALS_KEY belum diset atau tidak valid di server. API key
						tidak bisa disimpan sampai env ini diisi.
					</Alert>
				)}

				{loading ? (
					<Skeleton height={320} radius="md" />
				) : (
					<AiAssistantAdminProvider value={value}>
						{children}
					</AiAssistantAdminProvider>
				)}
			</Stack>
		</Container>
	);
}
